package com.devi3east.bashbuddy

import app.cash.sqldelight.ColumnAdapter
import kotlin.Long
import kotlin.String
import kotlin.collections.List

public data class Recipe(
  public val id: Long,
  public val title: String,
  public val description: String,
  public val category: String,
  public val area: String,
  public val imageUrl: String,
  public val youtubeLink: String,
  public val ingredients: List<String>,
  public val instructions: List<String>,
  public val isFavorite: Long,
  public val rating: Long,
  public val duration: String?,
  public val difficulty: String?,
) {
  public class Adapter(
    public val ingredientsAdapter: ColumnAdapter<List<String>, String>,
    public val instructionsAdapter: ColumnAdapter<List<String>, String>,
  )
}
